import { combineReducers } from 'redux'

import app from './appReducer'
import config from './configReducer'
import chart from './chartReducer'
import snack from './snackReducer'
import dialog from './dialogReducer'
import position from './positionReducer'

export default () =>
  combineReducers({
    app,
    config,
    chart,
    snack,
    dialog,
    position
  })
